import React from 'react';
import Tooltip from 'rc-tooltip';
import './_tooltip.scss';

const TooltipComponent = ({
  placement = 'top',
  trigger = ['hover'],
  children,
  ...otherProps
}) => (
  <Tooltip trigger={trigger} placement={placement} {...otherProps}>
    {children}
  </Tooltip>
);

export default TooltipComponent;
